<template>
  <b-row>
    <b-col md="12">
      <thank-you-stepper-base
        :image-src="require('@/assets/images/thanks.png')"
        image-container-class="thank-img text-center"
        title="Successfully Onboarded!"
        title-align="center"
        title-class="mt-3"
        :use-row-action="false"
        action-wrapper-class="text-center mt-4"
        action-button-class=""
        button-text="Go Back To Tenant Listing"
        button-variant="outline-primary"
        :button-btn-color="undefined"
        @done="$emit('done')"
      />
    </b-col>
  </b-row>
</template>
<script>
import ThankYouStepperBase from "@/components/Common/ThankYouStepperBase.vue";

export default {
  name: "ThankYou",
  components: {
    ThankYouStepperBase,
  },
};
</script>

<style scoped>
.thank-img img {
  width: 450px;
}
</style>